import classNames from "classnames";
import styles from "./styles/Chooseequipment.module.scss";
import { useTranslation } from "react-i18next";
import { Machine } from "./Domain/machine.interface";
import { mapMachineToImage } from "@mgi-labs/lib-liste-machine";

const Chooseequipment = ({ machines }: { machines: Machine[] | undefined }) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(
        styles.chooseequipment,
        styles.ht3,
        "col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
      )}
    >
      <div className={classNames(styles.containerzone)}>
        <div className={classNames(styles.equipmenttitle)}>
          <p>{t("myequipments")}</p>
          <div className={classNames(styles.equipmentaction)}></div>
        </div>

        <div className={classNames(styles.allequipments)}>
          {machines && machines.length > 0 && (
            <>
              {machines?.map((m) => (
                <div
                  title={m.name + "/" + m.serialNumber}
                  key={m.id}
                  className={classNames(styles.oneequipment)}
                >
                  <img src={mapMachineToImage(m.type)} alt={m.type} />
                  <p>
                    {m.name} / {m.serialNumber}
                  </p>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Chooseequipment;
